import { Shimmer } from "@repo/ui";

export const TopicSummaryWidgetShimmer = ({
  baseColor,
  highlightColor,
  cardWidth,
}: {
  baseColor: string;
  highlightColor: string;
  cardWidth: number;
}) => (
  <div
    style={{
      width: "100%",
      minWidth: cardWidth,
      maxWidth: "100%",
      height: 149,
      boxSizing: "border-box",
      borderRadius: 16,
      overflow: "hidden",
      padding: "24px 16px",
      backgroundColor: baseColor,
      display: "flex",
      flexDirection: "column",
      gap: 16,
      justifyContent: "space-between",
    }}
  >
    <Shimmer
      variant="textLine"
      width={32}
      height={20}
      shape="rounded"
      style={{ alignSelf: "flex-end" }}
      baseColor={baseColor}
      highlightColor={highlightColor}
      borderRadius={4}
    />
    <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
      <Shimmer
        variant="textLine"
        width="100%"
        height={16}
        shape="rounded"
        baseColor={baseColor}
        highlightColor={highlightColor}
        borderRadius={4}
      />
      <Shimmer
        variant="textLine"
        width="100%"
        height={16}
        shape="rounded"
        baseColor={baseColor}
        highlightColor={highlightColor}
        borderRadius={4}
      />
    </div>
    <Shimmer
      variant="card"
      height={10}
      shape="rounded"
      baseColor={baseColor}
      highlightColor={highlightColor}
      borderRadius={8}
    />
  </div>
);
